import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DisplayService } from '../../services/display/display.service';
@Component({
	selector: 'pcm-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit, OnChanges {

	@Input() actionLabel;
	@Input() canUpload = true;
	@Input() loaderId = '';
	@Input() removeFile: any;
	@Input() checkMulti = false;
	@ViewChild('fileInput') fileInput;
	
	@Output() upload: EventEmitter<any> = new EventEmitter();

	files;
	fileName = '';
	fileData;

	constructor(
		public displayService: DisplayService,
	) { }

	ngOnInit() {
		if (this.fileInput && this.fileInput.nativeElement) {
			this.fileInput.nativeElement.value  = '';
		}
	}
	ngOnChanges(changes) {
			this.reset();
	}
	browseFiles() {
		this.fileInput.nativeElement.click();
	}

	getFile() {
		const self = this;
		const fileContainer = this.fileInput.nativeElement;
		if (fileContainer.files && fileContainer.files[0]) {
			this.files = fileContainer.files;
		}
		if (this.files.length > 1) {
			self.fileName = this.files.length + ' files';
		} else {
			const fileReader = new FileReader();
			fileReader.onloadend = function (e) {
				const fileContents = fileReader.result;
				self.fileData = fileContents;
				self.fileName = self.files[0].name;
			};
			fileReader.readAsText(this.files[0]);
		}
	}
	reset() {
		this.files = undefined;
		if (this.fileInput && this.fileInput.nativeElement) {
			this.fileInput.nativeElement.value  = '';
		}
		this.fileData = undefined;
		this.fileName = '';
	}

	sendUpload() {
		this.upload.emit(this.files);
	}
}

